import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { useRef } from 'react';

import useIsEmbedded from 'hooks/useIsEmbedded';

import Footer from '../Footer/Footer';
import Navbar from '../Navbar/Navbar';

const pageLayoutCss = css`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
  /**
   * Prevent Shape components from enlarging the window horizontally.
   * e.g. Homepage on iPad emulation
   */
  overflow-x: hidden;
`;

const mainCss = bottomPadding => css`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  position: relative;
  padding-bottom: ${bottomPadding}px;
`;

/**
 * A wrapper around common pages that use the header and footer.
 *
 * Features:
 * - Renders NavBar and Footer (unless the site is embedded, e.g. in mobile app)
 * - Covers the whole available height of the page (sticks footer to bottom)
 * - Stretches the main content to fill the available space
 * - Adds configurable bottom padding to the main content
 *
 * @param {object} props
 */
function PageLayout({ children, className, bottomPadding = 60, currentSlug }) {
  const topNoticeRef = useRef(null);
  // Don't render the Navbar and Footer when embedded
  const isEmbedded = useIsEmbedded();

  return (
    <>
      {!isEmbedded && (
        <Navbar currentSlug={currentSlug} topNotice={topNoticeRef} />
      )}
      <div css={pageLayoutCss}>
        <main css={mainCss(bottomPadding)} className={className}>
          {children}
        </main>
        {!isEmbedded && <Footer />}
      </div>
    </>
  );
}

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  /** Can override the default bottom-padding of the main container */
  bottomPadding: PropTypes.number,
  currentSlug: PropTypes.string,
};

export default PageLayout;
